const CHUNK_RELOAD_KEY = "equiply:chunk-reload-attempted";

function errorMessageFromUnknown(value: unknown): string {
  if (value instanceof Error) return value.message;
  if (typeof value === "string") return value;
  return "";
}

function isChunkLoadError(value: unknown): boolean {
  const message = errorMessageFromUnknown(value).toLowerCase();
  if (!message) return false;

  return (
    message.includes("failed to fetch dynamically imported module") ||
    message.includes("dynamically imported module") ||
    message.includes("is not a valid javascript mime type") ||
    message.includes("error loading dynamically imported module") ||
    message.includes("importing a module script failed")
  );
}

export function recoverFromChunkLoadError(value: unknown): boolean {
  if (!isChunkLoadError(value)) return false;
  if (typeof window === "undefined") return false;

  const hasReloadedAlready = sessionStorage.getItem(CHUNK_RELOAD_KEY) === "1";
  if (hasReloadedAlready) return false;

  sessionStorage.setItem(CHUNK_RELOAD_KEY, "1");
  window.location.reload();
  return true;
}

export function clearChunkReloadAttempt(): void {
  if (typeof window === "undefined") return;
  sessionStorage.removeItem(CHUNK_RELOAD_KEY);
}
